import React from "react";
import Checkout6 from "../components/Checkout6";

const checkout6 = () => {
  return <Checkout6 />;
};

export default checkout6;
